import { gql, TypedDocumentNode } from "@apollo/client";

import { ApiKey, MutationApiKeyUpdateArgs } from "types/generated";

type PersonalApiKeyUpdate = {
  apiKeyUpdate: Pick<ApiKey, "id" | "name" | "description">;
};

export const UPDATE_PERSONAL_API_KEY: TypedDocumentNode<
  PersonalApiKeyUpdate,
  MutationApiKeyUpdateArgs
> = gql`
  mutation PersonalApiKeyUpdate($id: ID!, $input: ApiKeyUpdateInput!) {
    apiKeyUpdate(id: $id, input: $input) {
      id
      name
      description
    }
  }
`;
